export const isBrowser = () => typeof window !== 'undefined'

export const getSessionItem = (key: string) => {
  if (isBrowser() && sessionStorage) return sessionStorage.getItem(key)
  return null
}

export const setSessionItem = (key: string, value: string) => {
  if (isBrowser() && sessionStorage) return sessionStorage.setItem(key, value)
  return null
}

export const removeSessionItem = (key: string) => {
  if (isBrowser() && sessionStorage) return sessionStorage.removeItem(key)
}
